<template>
  <div class="pdp-aside-top">
    <!-- Replacing breadcrumbs with 'Back to Results' -->
    <div class="back-to-results-container text-uppercase mb-2">
      <a
        href="javascript:void(0)"
        @click="goBack"
        class="color-light-grey back-to-results-link"
      >
        <!-- Add Font Awesome icon inline -->
        <span class="icon-container">
          <i class="fa fa-long-arrow-left" aria-hidden="true"></i>
        </span>
        <span class="back-to-results-text ml-1"> Back to Results </span>
      </a>
    </div>

    <h4
      class="primary-heading mb-0 font-weight-bold mb-3 patcraft-text-underline"
      :data-text="processedHeading ? processedHeading.slice(0, 3) : ''"
    >
      {{ processedHeading }}
    </h4>
    <div class="description text-uppercase">
      <ul class="list-unstyled mb-0 mobile-view">
        <li class="color-light-grey">{{ sellingStyleNumber }}</li>
        <li v-if="!isResinous" class="product-size-imperial">
          {{ selectedProduct.productSizeImperial }}
        </li>
      </ul>
    </div>

    <div class="description text-uppercase">
      <ul class="list-unstyled d-flex flex-wrap flex-column dividers-primary mx-n2">
        <li
          class="px-2 border-0 mt-1"
          v-if="collectionRedirect || (productData && productData.collectionCode)"
        >
          <a
            class="collection-link"
            :href="
              collectionRedirect
                ? collectionRedirect
                : '/product-collection/' +
                  getCollectionLink(
                    productData.collectionCode.description,
                    productData.collectionCode.code
                  )
            "
          >
            {{ productData.collectionCode.description }}
          </a>
        </li>

        <li
          v-if="
            productData.specificationCustomData &&
            productData.specificationCustomData.patentStatus
          "
          class="px-2"
        >
          {{ productData.specificationCustomData.patentStatus }}
        </li>
      </ul>
    </div>

    <pc-product-color-variation
      v-if="
        selectedColor.colorVariationLevel &&
        selectedColor.colorVariationLevel.code &&
        productData.inventoryType == 'resilient'
      "
      :specification="false"
    >
    </pc-product-color-variation>

    <!-- Weldrods Modal -->
    <pc-product-recommended-weldrods v-if="weldRodsEnabled" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PCSpecificationsRating from "./pc-product-color-variation.vue";
import PCRecommendedWeldRods from "./pc-product-recommended-weldrods.vue";

export default {
  props: ["collectionRedirect", "weldRodsEnabled"],
  components: {
    "pc-product-color-variation": PCSpecificationsRating,
    "pc-product-recommended-weldrods": PCRecommendedWeldRods,
  },
  computed: {
    ...mapGetters({
      rugsSizesOptions: "productDetail/rugsSizesOptions",
      sellingStyleNumber: "productDetail/sellingStyleNumber",
      selectedColor: "productDetail/color",
      productData: "productDetail/productData",
      isRug: "productDetail/isRug",
      selectedProduct: "productDetail/selectedProduct",
      isComingSoonProduct: "productDetail/isComingSoonProduct",
      description: "productDetail/description",
      getImperialDisplayValue: "productDetail/getImperialDisplayValue",
    }),
    isResinous() {
      return (
        this.productData &&
        this.productData.inventoryType === this.$resourceString["resinous.InventoryType"]
      );
    },
    processedHeading() {
      return this.isRug
        ? this.selectedProduct?.sellingStyleName
        : this.productData?.sellingStyleName;
    },
  },
  methods: {
    getCollectionLink(description, code) {
      if (this.isResinous) {
        return code;
      }
      return description?.includes("&") ? code ?? "" : description;
    },
    goBack() {
      window.history.back();
    },
  },
};
</script>
